export const calculateBoxPercentage = (videoWidth, videoHeight, boxX, boxY, boxWidth, boxHeight) => {
  const x = (boxX / videoWidth) * 100;
  const y = (boxY / videoHeight) * 100;
  const width = (boxWidth / videoWidth) * 100;
  const height = (boxHeight / videoHeight) * 100;

  return {
    x,
    y,
    width,
    height
  };
}
export const calculateBoxFromPercentage = (videoWidth, videoHeight, xPercent, yPercent, widthPercent, heightPercent) => {
  const x = Math.round((xPercent / 100) * videoWidth);
  const y = Math.round((yPercent / 100) * videoHeight);
  const width = Math.round((widthPercent / 100) * videoWidth);
  const height = Math.round((heightPercent / 100) * videoHeight);

  return {
    x,
    y,
    width,
    height
  };
}

export const fitToFrame = (originalWidth, originalHeight, maxWidth, maxHeight) => {
  const aspectRatio = originalWidth / originalHeight;
  let newWidth, newHeight;

  // Check if scaling by width or height based on which fits better
  if (maxWidth / aspectRatio <= maxHeight) {
    // Width is the constraint
    newWidth = maxWidth;
    newHeight = maxWidth / aspectRatio;
  } else {
    // Height is the constraint
    newHeight = maxHeight;
    newWidth = maxHeight * aspectRatio;
  }

  return { newWidth, newHeight };
}
  
  export const getRandomColorExcludingGreen = () => {
    let letters = '0123456789ABCDEF';
    let color;
    do {
      color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
    } while (color.startsWith('#00') || color.includes('0') && color.includes('8') && color.includes('0')); // Exclude shades of green
    return color;
  };

  
  // Function to generate multiple unique color codes excluding green
  export const generateUniqueColors = (count) => {
    let colors = new Set();
    while (colors.size < count) {
      let color = getRandomColorExcludingGreen();
      if (!(color in colors)) {
        colors.add(getRandomColorExcludingGreen());
      }
    }
    return Array.from(colors);
  };

export const calculateCenterPosition = (largeWidth, largeHeight, smallWidth, smallHeight) => {
  const left = (largeWidth - smallWidth) / 2;
  const top = (largeHeight - smallHeight) / 2;
  return { left, top };
}

export const sortObjectArrayByKey = (array, key, order = "asc") => {
  return array.sort((a, b) => {
    if (a[key] < b[key]) return order === "asc" ? -1 : 1;
    if (a[key] > b[key]) return order === "asc" ? 1 : -1;
    return 0;
  });
};

export const capitalize = (s) => {
  return String(s[0]).toUpperCase() + String(s).slice(1);
}

export function decodeUrlEncodedString(encodedStr) {
  try {
    return decodeURIComponent(encodedStr);
  } catch (e) {
    console.error("Failed to decode string:", encodedStr, e);
    return encodedStr;
  }
}

export const capitalizeLabel = (label) => {
  const capitalWords = ['CPU', 'GPU', 'RAM'];
  return label
    .split('_')
    .map((word) =>
      capitalWords.includes(word.toUpperCase()) ? word.toUpperCase() : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join(' ');
};